/* Figma: 2161:7199 — 1228x50, px 52 py 8, bg white, bottom border #e6e6e6 */
.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--topbar-h);
  padding: 8px 52px;
  background: #fff;
  border-bottom: 1px solid var(--header-border);
}

.title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: var(--header-text);
}

.controls { display: flex; align-items: center; gap: 10px; }

/* Trend Chart selector — 2194:5185. Shares --control-h with the date and
   profile pills: three controls of three different heights in one row read as
   a layout bug, whatever each was traced from individually. */
.trend {
  display: flex;
  align-items: center;
  gap: 6px;
  height: var(--control-h);
  padding: 0 12px;
  background: #fff;
  border: 1px solid var(--header-border);
  border-radius: var(--radius-sm);
}
.trendLabel {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--header-text-muted);
  white-space: nowrap;
}
.trendValue {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--header-text);
  white-space: nowrap;
}

/* Date range.
   Was a fixed 196x34 traced from the comp, where the dates are placeholders.
   Real ones are longer — "Last 7 Days: 29 Aug 2026 - 04 Sep 2026" ran right up
   under the chevron — and at 9px/8px they were barely legible next to a 18px
   title. Sized to content now, at the Targeting 360 header's proportions. */
.dateRange {
  display: flex;
  align-items: center;
  gap: 8px;
  height: var(--control-h);
  padding: 0 12px;
  background: #fff;
  border: 1px solid var(--header-border);
  border-radius: var(--radius-sm);
}
.calendar { width: 20px; height: 20px; flex-shrink: 0; }
.dateText { display: flex; flex-direction: column; gap: 1px; font-family: 'Open Sans Variable', 'Open Sans', var(--font-family); }
.datePrimary { font-size: 11px; line-height: 16px; color: var(--header-text); white-space: nowrap; }
.datePrimary strong { font-weight: 600; }
.dateCompare { font-size: 10px; line-height: 14px; color: var(--header-text-muted); white-space: nowrap; }

.icon20 { width: 20px; height: 20px; flex-shrink: 0; }
.icon16 { width: 16px; height: 16px; flex-shrink: 0; }

/* User button — 2161:7281, 35x32 with overlapping user + caret */
.userBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 32px;
  padding: 8px;
  background: #fff;
  border-radius: var(--radius-sm);
}
.userStack { position: relative; width: 27px; height: 16px; }
.userIcon { position: absolute; left: 0; top: 0; width: 16px; height: 16px; }
.userCaret { position: absolute; left: 15px; top: 1px; width: 12px; height: 12px; }

.account { position: relative; }

.menu {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  z-index: 20;
  min-width: 168px;
  padding: 6px;
  background: #fff;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-chip);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}
.menuUser {
  margin: 0;
  padding: 6px 10px 8px;
  font-size: 11px;
  line-height: 14px;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border-cell);
  word-break: break-word;
}
.menuItem {
  width: 100%;
  padding: 8px 10px;
  border-radius: var(--radius-sm);
  text-align: left;
  font-size: 12px;
  line-height: 16px;
  color: var(--text-value);
}
.menuItem:hover { background: var(--bg-table-header); }

.settings { width: 268px; padding: 12px; }
.settingsHead { margin: 0 0 8px; font-size: 11px; font-weight: 600; letter-spacing: .04em; text-transform: uppercase; color: var(--text-muted); }
.settingsRow { display: flex; justify-content: space-between; gap: 12px; margin: 0 0 6px; font-size: 12px; color: var(--text-muted); }
.settingsRow strong { color: var(--text-value); font-weight: 600; }
.settingsAction { width: 100%; margin-top: 8px; padding: 8px; border: 1px solid var(--border-control); border-radius: 6px; font-size: 12px; color: var(--text-value); }
.settingsAction:hover { background: var(--bg-table-header); }
